import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const TagColorTagFragmentDoc = gql`
  fragment TagColorTag on Tag {
    id
    color
    name
    tagType
  }
` as unknown as DocumentNode<Types.TagColorTagFragment, unknown>
